// UserLevelGemstone.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Level1Src from '../../img/img_livestream_vip_l_1.svg';
import Level2Src from '../../img/img_livestream_vip_l_2.svg';
import Level3Src from '../../img/img_livestream_vip_l_3.svg';

export const UserLevelGemstone = ({ level, size }) => {
  if (!level) return null;
  let GemstoneSrc = null;
  switch (level) {
    case 1:
      GemstoneSrc = Level1Src;
      break;
    case 2:
      GemstoneSrc = Level2Src;
      break;
    case 3:
      GemstoneSrc = Level3Src;
      break;
    default:
      break;
  }
  return (
    <StyledUserLevelGemstone
      src={GemstoneSrc}
      alt={`User L${level}`}
      size={size}
    />
  );
};

UserLevelGemstone.propTypes = {
  level: PropTypes.number,
  size: PropTypes.number,
};

UserLevelGemstone.defaultProps = {
  level: null,
  size: 36,
};

const StyledUserLevelGemstone = styled.img`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;

export default UserLevelGemstone;
